/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SportBallBasketballIcon16Light } from './SportBallBasketballIcon16Light';
import { SportBallBasketballIcon16Regular } from './SportBallBasketballIcon16Regular';
import { SportBallBasketballIcon16Solid } from './SportBallBasketballIcon16Solid';
import { SportBallBasketballIcon20Light } from './SportBallBasketballIcon20Light';
import { SportBallBasketballIcon20Regular } from './SportBallBasketballIcon20Regular';
import { SportBallBasketballIcon20Solid } from './SportBallBasketballIcon20Solid';
import { SportBallBasketballIcon24Regular } from './SportBallBasketballIcon24Regular';
import { SportBallBasketballIcon24Solid } from './SportBallBasketballIcon24Solid';
import { SportBallBasketballIcon32Regular } from './SportBallBasketballIcon32Regular';
import { SportBallBasketballIcon64Regular } from './SportBallBasketballIcon64Regular';
var sizes = {
    16: {
        light: SportBallBasketballIcon16Light,
        regular: SportBallBasketballIcon16Regular,
        solid: SportBallBasketballIcon16Solid,
    },
    20: {
        light: SportBallBasketballIcon20Light,
        regular: SportBallBasketballIcon20Regular,
        solid: SportBallBasketballIcon20Solid,
    },
    24: {
        regular: SportBallBasketballIcon24Regular,
        solid: SportBallBasketballIcon24Solid,
    },
    32: {
        regular: SportBallBasketballIcon32Regular,
    },
    64: {
        regular: SportBallBasketballIcon64Regular,
    },
};
export var SportBallBasketballIcon = forwardRef('SportBallBasketballIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
